// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Paneller',
  subtitle: 'Hosting panellerini yönetin',
  addNew: 'Yeni Panel',
  edit: 'Düzenle',
  panelName: 'Panel Adı',
  panelType: 'Panel Tipi',
  url: 'URL',
  username: 'Kullanıcı Adı',
  password: 'Şifre',
  notes: 'Notlar',
  status: 'Durum',
  actions: 'İşlemler',
  noPanels: 'Henüz panel tanımlanmamış',
  noPanelsDesc: 'İlk paneli ekleyerek başlayın.',
  panelAdded: 'Panel başarıyla eklendi',
  panelUpdated: 'Panel başarıyla güncellendi',
  panelDeleted: 'Panel başarıyla silindi',
  fetchError: 'Paneller alınamadı',
  addError: 'Panel eklenemedi',
  updateError: 'Panel güncellenemedi',
  deleteError: 'Panel silinemedi',
  confirmDelete: 'Bu paneli silmek istediğinizden emin misiniz?',
  typeCpanel: 'cPanel',
  typePlesk: 'Plesk',
  typeDirectadmin: 'DirectAdmin',
  typeVestacp: 'VestaCP',
  typeOther: 'Diğer',
  paymentAnalysis: 'Ödeme Analizi',
  recurringPaymentsAnalysis: 'Tekrarlı Ödeme Analizi'
};
